import React, { useState, useEffect, useRef } from 'react';

import { formatNumber, getInputValue, formatNumericValue, parseInputValue } from '../utils';

const TestingSection = ({ totalCost = 0, onChange, isEditable = true, perStyleTestingCost }) => {
	const [testingCost, setTestingCost] = useState(perStyleTestingCost);
	const isInitialMount = useRef(true);
	const prevValueRef = useRef(null);

	useEffect(() => {
		if (prevValueRef.current === perStyleTestingCost) {
			return;
		}

		if (perStyleTestingCost !== '' && perStyleTestingCost !== null && perStyleTestingCost !== undefined) {
			setTestingCost(formatNumericValue(perStyleTestingCost));
		} else {
			setTestingCost(perStyleTestingCost);
		}

		prevValueRef.current = perStyleTestingCost;
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}
	}, [perStyleTestingCost]);

	const notifyChange = (testingCost) => {
		if (onChange && !isInitialMount.current) {
			onChange(formatNumericValue(testingCost));
		}
	};

	const handleInputChange = (e) => {
		const value = e.target.value;
		const testingCost = parseInputValue(value);
		setTestingCost(testingCost);
		notifyChange(testingCost);
	};

	const displayCost = totalCost || 0;

	return (
		<div className="single-table trims-content border mt-5">
			<div className="table-heading d-flex align-items-center justify-content-between">
				<p>Testing Cost Metrics</p>
			</div>
			<div className="row align-items-center py-2 border-bottom border-top m-0">
				<div className="col-md-2 pr-0">
					<p className="regular-12 gray_dark_02 pb-1">Testing Cost Per Style($)</p>
				</div>
				<div className="col-md-10">
					<input
						type="number"
						step="0.01"
						value={getInputValue(testingCost)}
						onChange={handleInputChange}
						readOnly={!isEditable}
					/>
				</div>
			</div>
			<div className="row align-items-center m-0 total-row">
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01">Total Testing Cost</p>
				</div>
				<div className="col-md-6 col-sm-12 mb-2 mb-0">
					<p className="semibold-14 gray_dark_01 float-right">${formatNumber(displayCost)}</p>
				</div>
			</div>
		</div>
	);
};

export default TestingSection;
